/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { PureComponent } from 'react';
import UILink from 'UIComponents/link/UILink';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextInput from 'UIComponents/input/UITextInput';
import Small from 'UIComponents/elements/Small';
import UIDropZone from 'UIComponents/drop/UIDropZone';
import styled from 'styled-components';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import text from 'I18n/utils/unescapedText';
import UIFileButton from 'UIComponents/button/UIFileButton';
import UIFileAttachment from 'UIComponents/attachment/UIFileAttachment';
import UIGrid from 'UIComponents/grid/UIGrid';
import UIGridItem from 'UIComponents/grid/UIGridItem';
import I18n from 'I18n';
import UIIcon from 'UIComponents/icon/UIIcon';
import { FONT_FILE_TYPES, ModalPages } from 'ContentData/constants/fonts';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIButton from 'UIComponents/button/UIButton';
import * as fontsSelectors from 'ContentData/selectors/fonts';
import { connect } from 'react-redux';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const stopEvent = e => {
  e.preventDefault();
  e.stopPropagation();
};
const i18nKey = key => `ContentComponents.cmv2.fields.font.modals.upload.add.${key}`;
const DropBoxContents = styled.div.withConfig({
  displayName: "AddCustomFont__DropBoxContents",
  componentId: "ure1o1-0"
})(["width:80%;margin:auto;"]);
const TextInputContainer = styled.div.withConfig({
  displayName: "AddCustomFont__TextInputContainer",
  componentId: "ure1o1-1"
})(["max-width:350px;"]);
const DragContainer = styled.div.withConfig({
  displayName: "AddCustomFont__DragContainer",
  componentId: "ure1o1-2"
})(["& *{pointer-events:none;}& button{pointer-events:auto;}&.isHovered button{pointer-events:none;}"]);
const FileDropState = Object.freeze({
  DEFAULT: 'default',
  ERROR: 'error',
  HOVER: 'hover',
  DONE: 'default'
});
const mapStateToProps = state => {
  return {
    customFonts: fontsSelectors.getCustomFonts(state)
  };
};
const connector = connect(mapStateToProps);
class AddCustomFont extends PureComponent {
  constructor(props) {
    super(props);
    this.onNameChange = e => {
      const {
        handleUpdate
      } = this.props;
      const name = e.target.value;
      handleUpdate({
        fontName: name
      });
    };
    this.handleDragEnter = () => {
      const {
        fileDropState
      } = this.state;
      if (fileDropState !== FileDropState.HOVER) {
        this.setState({
          fileDropState: FileDropState.HOVER
        });
      }
    };
    this.handleDragLeave = () => {
      const {
        fileDropState
      } = this.state;
      if (fileDropState === FileDropState.HOVER) {
        this.setState({
          fileDropState: FileDropState.DEFAULT
        });
      }
    };
    this.handleDrop = e => {
      stopEvent(e);
      const {
        fileDropState
      } = this.state;
      const {
        addFiles
      } = this.props;
      const {
        dataTransfer: {
          files
        }
      } = e;
      if (fileDropState === FileDropState.HOVER && e.dataTransfer.files[0]) {
        addFiles(files);
        this.setState({
          fileDropState: FileDropState.DONE
        });
      } else {
        this.setState({
          fileDropState: FileDropState.ERROR
        });
      }
    };
    this.onNext = () => {
      const {
        customFonts,
        handleUpdate,
        setErrorMessage,
        fontName
      } = this.props;
      if (fontName && Object.keys(customFonts).includes(fontName)) {
        setErrorMessage(i18nKey('error.fontMustHaveUniqueName'));
      } else {
        handleUpdate({
          page: ModalPages.EDIT
        });
      }
    };
    this.renderPageNext = () => {
      const {
        fontName,
        fontFiles
      } = this.props;
      const pageIsReadyForNext = fontName && fontFiles && fontFiles.length;
      return /*#__PURE__*/_jsx(UITooltip, {
        placement: "right",
        disabled: !!pageIsReadyForNext,
        title: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: i18nKey(`pagination.disabledTooltip`)
        }),
        children: /*#__PURE__*/_jsx(UIButton, {
          use: "primary",
          disabled: !pageIsReadyForNext,
          onClick: () => this.onNext(),
          "data-selenium": "font-upload-add-next-button",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('pagination.next')
          })
        })
      });
    };
    this.renderCancel = () => {
      const {
        customFonts,
        changePage
      } = this.props;
      return !!Object.keys(customFonts).length && /*#__PURE__*/_jsx(UIButton, {
        use: "secondary",
        onClick: () => changePage(ModalPages.MANAGE),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('pagination.cancel')
        })
      });
    };
    this.state = {
      fileDropState: FileDropState.DEFAULT
    };
  }
  renderNameInput() {
    const {
      fontName
    } = this.props;
    return /*#__PURE__*/_jsx(UIFormControl, {
      label: text(i18nKey('form.name.label')),
      required: true,
      children: /*#__PURE__*/_jsx(TextInputContainer, {
        children: /*#__PURE__*/_jsx(UITextInput, {
          name: "font-name",
          placeholder: text(i18nKey('form.name.placeholder')),
          onChange: this.onNameChange,
          value: fontName,
          "data-selenium": "font-upload-name-input"
        })
      })
    });
  }
  renderFileUploadDropArea() {
    const {
      fileDropState
    } = this.state;
    const {
      addFiles
    } = this.props;
    return /*#__PURE__*/_jsx(DragContainer, {
      className: fileDropState === FileDropState.HOVER ? "isHovered" : "",
      onDragOver: stopEvent,
      onDrop: this.handleDrop,
      onDragEnter: this.handleDragEnter,
      onDragLeave: this.handleDragLeave,
      children: /*#__PURE__*/_jsx(UIDropZone, {
        size: "large",
        use: fileDropState,
        children: /*#__PURE__*/_jsxs(DropBoxContents, {
          children: [/*#__PURE__*/_jsx(UIFileButton, {
            size: "sm",
            multiple: true,
            onChange: e => addFiles(e.target.files),
            accept: FONT_FILE_TYPES,
            "data-selenium": "font-upload-files-input",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey('form.chooseFile.button')
            })
          }), /*#__PURE__*/_jsx("p", {
            className: "m-top-3",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey(`form.chooseFile.${fileDropState === FileDropState.ERROR ? 'error' : 'description'}`)
            })
          })]
        })
      })
    });
  }
  renderFilesUploadedListing() {
    //TODO restrict file types to listed font files
    //TOFO font file icon custom?? in mock it's different
    const {
      fontFiles,
      addFiles,
      removeFile
    } = this.props;
    return fontFiles && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(UIGrid, {
        children: fontFiles.map((file, index) => /*#__PURE__*/_jsx(UIGridItem, {
          size: 6,
          children: /*#__PURE__*/_jsx(UIFileAttachment, {
            className: "m-bottom-2",
            fileName: file.fileName,
            fileInfo: file.fileSize && I18n.formatSize(file.fileSize),
            size: "small",
            closeable: true,
            onCloseClick: () => removeFile(index, file.fileName),
            "data-selenium": `font-upload-files-uploaded:${file.fileName}`
          })
        }, file.fileName))
      }), /*#__PURE__*/_jsxs(UIFileButton, {
        use: "transparent",
        multiple: true,
        onChange: e => addFiles(e.target.files),
        accept: FONT_FILE_TYPES,
        "data-selenium": "font-upload-files-input",
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: "add"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('form.chooseFile.addMoreFiles')
        })]
      })]
    });
  }
  renderFileUpload() {
    const {
      fontFiles
    } = this.props;
    return /*#__PURE__*/_jsx("div", {
      className: "m-top-5",
      children: fontFiles && fontFiles.length > 0 ? this.renderFilesUploadedListing() : this.renderFileUploadDropArea()
    });
  }
  render() {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(UIDialogBody, {
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: i18nKey('body')
          })
        }), /*#__PURE__*/_jsxs("p", {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('bodySupport')
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(UILink, {
            href: "https://knowledge.hubspot.com/website-pages/use-fonts-in-hubspot#use-custom-fonts",
            external: true,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey('linkLearnMore')
            })
          })]
        }), this.renderNameInput(), this.renderFileUpload(), /*#__PURE__*/_jsx(Small, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('form.chooseFile.disclaimer')
          })
        })]
      }), /*#__PURE__*/_jsxs(UIDialogFooter, {
        children: [this.renderPageNext(), this.renderCancel()]
      })]
    });
  }
}
export default connector(AddCustomFont);